import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";


export default function useGetAllWorkflowsV2(shopId: string) {
  return $api.useQuery("get", "/shops/{shopId}/workflows-v2", {
    params: { path: { shopId } },
  });
}


export function useGetAllWorkflowsV2Suspense(shopId: string) {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/workflows-v2", {
    params: { path: { shopId } },
  });
}

export const invalidateAllWorkflowsV2Key = (shopId: string) => [
  "get",
  "/shops/{shopId}/workflows-v2",
  { params: { path: { shopId } } },
];

export function useInvalidateAllWorkflowsV2() {
  const client = useQueryClient();
  return (shopId: string) => {
    client.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/workflows-v2",
        { params: { path: { shopId } } },
      ],
    });
  };
}

